import { takeLatest, put } from 'redux-saga/effects';
import {
  SIM_IS_INSTALLED,
  SIM_IS_INSTALLED_REQUEST,
  SIM_IS_RUNNING,
  SIM_IS_RUNNING_REQUEST,
  SIM_ISVT_ENABLED,
  SIM_ISVT_ENABLED_REQUEST,
} from '../constants/asimstatus';
import { PCStoreJsBridge } from '../nativeapi';

function* fetchGetSIMIsVTEabled() {
  try {
    const ret = yield PCStoreJsBridge.getIsVTEabled();
    yield put({ type: SIM_ISVT_ENABLED, isVTEabled: ret.vt === true });
  } catch (error) {
    // throw error;
  }
}

function* fetchGetIsSIMRunning() {
  try {
    const ret = yield PCStoreJsBridge.getIsSIMRunning();
    yield put({ type: SIM_IS_RUNNING, isSIMRunning: ret === true });
  } catch (error) {
    // throw error;
  }
}

function* fetchGetIsSIMInstalled() {
  try {
    const ret = yield PCStoreJsBridge.getIsSIMInstalled();
    yield put({ type: SIM_IS_INSTALLED, isSIMInstalled: ret === true });
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchGetSIMIsVTEabled() {
  yield takeLatest(SIM_ISVT_ENABLED_REQUEST, fetchGetSIMIsVTEabled);
}

export function* watchFetchGetIsSIMRunning() {
  yield takeLatest(SIM_IS_RUNNING_REQUEST, fetchGetIsSIMRunning);
}

export function* watchFetchGetIsSIMInstalled() {
  yield takeLatest(SIM_IS_INSTALLED_REQUEST, fetchGetIsSIMInstalled);
}
